import SimpleChoice from "../../common/SimpleChoiceVO";
import {NICounty} from "../../manager/GeneralManager";

export default class AddressVO
{
    title: string = "";
    buildingName: string = "";
    address: string = "";
    town: string = "";
    county: string = "";
    postcode: string = "";
    countryCode: string = "";
    countryName: string = "";
    niCounty: NICounty = "none";

    quickLocation():string
    {
        return this.town + (!!this.town && !!this.county ? ", " : "") + this.county;
    }

    getAddressDetails():SimpleChoice[]
    {
        const address = this.buildingName + (!!this.buildingName && !!this.address ? " " : "") + this.address;
        const details:SimpleChoice[] = [];
        if(address){
            details.push(new SimpleChoice("address", address));
        }
        if(this.town){
            details.push(new SimpleChoice("town", this.town));
        }
        if(!details.length){
            return [];
        }
        if(this.county){
            details.push(new SimpleChoice("county", this.county));
        }
        if(this.postcode){
            details.push(new SimpleChoice("postcode", this.postcode));
        }
        if(this.countryName){
            details.push(new SimpleChoice("country", this.countryName));
        }
        return details;
    }

    getAddressDetailsGMap(): string
    {
        const addressDetails = this.getAddressDetails();
        if(!addressDetails){
            return "";
        }
        let string = this.title;
        for(let detail of addressDetails){
            string += string ? ", " : "";
            string += detail.name;
        }
        return encodeURI(string)
    }
}